import React, { forwardRef, useState, useEffect, useContext } from 'react'
import {
  Dialog,
  DialogContent,
  IconButton,
  Grow,
  Box,
  Typography,
  Button,
  Grid,
  Snackbar,
} from '@mui/material'
import { motion } from 'framer-motion'
import { Close, ContentCopy } from '@mui/icons-material'

import { AnimatePresence } from 'framer-motion'
import { renderMuiFormField } from 'utils/forms/renderMuiFormField'
import { selectData } from 'layouts/onboarding'
import giftcard from 'assets/images/illustrations/giftcard.svg'
import { callZapier } from 'utils/zapier/callZapier'
import { IntakeContext } from 'context/IntakeContext'
import { useFormDebounce } from 'hooks/useFormDebounce'
import email from 'assets/images/email.png'
import ScrollingLogos from 'components/ScrollingLogos'

const Transition = forwardRef(function Transition(props, ref) {
  return <Grow timeout={300} ref={ref} {...props} />
})

export function TesterSignup({ onClose }) {
  const { intakeState, updateIntakeStateAtKey } = useContext(IntakeContext)
  const { updateIntakeStateAndSubmit } = useFormDebounce()

  const [direction, setDirection] = useState(1)
  const variants = {
    enter: (dir) => ({
      x: dir > 0 ? 300 : -300,
      opacity: 0,
    }),
    center: {
      x: 0,
      opacity: 1,
    },
    exit: (dir) => ({
      x: dir > 0 ? -300 : 300,
      opacity: 0,
    }),
  }

  return (
    <>
      <Dialog
        open
        onClose={onClose}
        TransitionComponent={Transition}
        fullWidth
        maxWidth={'md'}
        PaperProps={{ sx: { overflow: 'visible', maxHeight: '80vh' } }}
      >
        <Box
          sx={{
            justifyContent: 'space-between',
            position: 'relative',
            top: -64,
          }}
        >
          <IconButton
            onClick={onClose}
            sx={{
              position: 'absolute',
              top: 0,
              right: -16,
              color: '#fff',
              zIndex: 1,
              backgroundColor: '#000',
              '&:hover': {
                backgroundColor: '#000',
              },
            }}
          >
            <Close />
          </IconButton>
        </Box>
        <DialogContent sx={{ overflow: 'scroll' }}>
          <AnimatePresence mode="wait" custom={direction}>
            <motion.div
              custom={direction}
              variants={variants}
              initial="enter"
              animate="center"
              exit="exit"
              transition={{ duration: 0.3 }}
              style={{
                position: 'relative',
                width: '100%',
              }}
            >
              <Box
                px={{ xs: 0, sm: 6 }}
                pt={{ xs: 4, sm: 6 }}
                pb={{ xs: 2, sm: 6 }}
              >
                <Typography
                  variant="headerTitle"
                  color="#262627"
                  textAlign="left"
                  display="block"
                >
                  Help us to improve the PARCO platform!
                </Typography>
                <Typography
                  variant="body1"
                  mt={3}
                  color="#495057"
                  textAlign="left"
                >
                  We're running user experience-reviews to learn about your
                  experience with the PARCO platform and how we can improve.
                </Typography>{' '}
                <Typography
                  variant="body1"
                  mt={3}
                  mb={2}
                  color="#495057"
                  textAlign="left"
                >
                  Click the link below to get started. If you qualify and
                  complete a review session, <strong>you'll receive $25</strong>{' '}
                  as a thank you for your time.
                </Typography>
                <ScrollingLogos />
                <Box
                  display="flex"
                  justifyContent="space-between"
                  gap={2}
                  mt={3}
                >
                  <Button
                    onClick={onClose}
                    variant="parcoRounded"
                    color="outline"
                  >
                    Not Interested
                  </Button>
                  <Box display="flex" justifyContent="flex-end" gap={3}>
                    <Button
                      onClick={onClose}
                      variant="parcoRounded"
                      color="outline"
                    >
                      Maybe Later
                    </Button>
                    <Button
                      onClick={() => {
                        console.log('set up meeting')
                      }}
                      variant="parcoRounded"
                    >
                      Let's do it!
                    </Button>
                  </Box>
                </Box>
              </Box>
            </motion.div>
          </AnimatePresence>
        </DialogContent>
      </Dialog>
    </>
  )
}
